/**
 * User project permissions API – share project with a user by email.
 * Matches backend POST /api/user-project-permissions.
 */

import apiClient from '../../../../shared/lib/apiClient';

export type PermissionLevel = 'read' | 'readwrite';

export interface AddProjectPermissionRequest {
  user_email: string;
  project_id: string;
  permission: PermissionLevel;
}

export interface AddProjectPermissionResponse {
  status: string;
  message: string;
  data?: {
    user_id: string;
    user_email: string;
    project_id: string;
    permission: string;
    project_permissions: Array<{ project_id: string; permission: string }>;
    created_at: string;
    updated_at: string;
  };
}

/**
 * Add or update project permission for a user (by email).
 * Resolves user_id via Cognito; returns 404 if user not found.
 */
export async function addProjectPermission(
  request: AddProjectPermissionRequest
): Promise<AddProjectPermissionResponse> {
  return apiClient<AddProjectPermissionResponse>('/userprojectpermissions', {
    method: 'POST',
    body: request,
    requireAuth: true,
  });
}
